import SelectInput from "@/modules/common/components/ui-kit/inputs/select-input";
import RankTarget from "@/modules/targets/components/target-configurations/targets-template/rank-target";
import useRanksWithTarget from "@/modules/targets/hooks/ranks-with-target.hook";
import { targetTypeOptions } from "@/modules/targets/constants";
import { TargetTypes } from "@/modules/targets/types";
import { Stack, useTheme } from "@mui/material";
import { useTargetsTemplateContext } from "@/modules/targets/context/targets-template.context";

const CreateTargetsTemplate = ({
  subDepartmentUid,
}: {
  subDepartmentUid: string;
}) => {
  const theme = useTheme();

  const { ranksWithTarget } = useRanksWithTarget({ subDepartmentUid });

  const { targetType, setTargetType } = useTargetsTemplateContext();

  return (
    <Stack
      direction="column"
      width="100%"
      padding={theme.nawy.spacing.md}
      spacing={theme.nawy.spacing.md}
    >
      <SelectInput
        label="Target Type"
        value={targetType}
        onChange={(e) => setTargetType(e.target.value as TargetTypes)}
        options={targetTypeOptions}
      />

      <Stack direction="column" spacing={theme.nawy.spacing.md} width="100%">
        {ranksWithTarget.map((rank) => (
          <RankTarget key={rank.id} rank={rank} />
        ))}
      </Stack>
    </Stack>
  );
};

export default CreateTargetsTemplate;
